export function statusLableColor(status) {
  let statusBackgroundColor, statusColor;

  if (status === "pending") {
    statusBackgroundColor = "rgba(236, 148, 44, 0.15)";
    statusColor = "#EC942C";
  } else if (status === "approved" || status === "accepted") {
    statusBackgroundColor = "rgba(4, 201, 0, 0.1)";
    statusColor = "#04C900";
  } else if (status === "rejected") {
    statusBackgroundColor = "rgba(255, 0, 0, 0.08)";
    statusColor = "#FF0000";
  } else if (status === "processing") {
    statusBackgroundColor = "rgba(151, 151, 151, 0.15)";
    statusColor = "#848696";
  }

  return { statusBackgroundColor, statusColor };
}
